import { publicRouteNames } from '~/middleware/auth.global'

/**
 * Plugin responsável por garantir o sincronismo do estado de autenticação do usuário
 * entre diferentes abas ou situações de dessincronização,
 * redirecionando automaticamente para a rota adequada
 */
export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()
  const route = useRoute()

  watch(
    () => authStore.isUserAuthenticated,
    (isAuthenticated) => {
      const isCurrentRoutePublic = publicRouteNames.some((name) =>
        String(route.name).includes(name),
      )

      if (isAuthenticated && isCurrentRoutePublic) {
        return navigateTo({ name: 'select-organization' }) // redirect após login
      }

      if (!isAuthenticated && !isCurrentRoutePublic) {
        return navigateTo({ name: 'auth-login' }) // redirect após logout
      }
    },
    { immediate: true },
  )
})
